const ROOT_BASE_PATH = "/";

const ensureLeadingSlash = (value: string): string => {
  return value.startsWith("/") ? value : `/${value}`;
};

export const normalizeBasePath = (value?: string): string => {
  if (!value) {
    return ROOT_BASE_PATH;
  }

  const trimmed = value.trim();

  if (!trimmed || trimmed === ROOT_BASE_PATH) {
    return ROOT_BASE_PATH;
  }

  const withLeadingSlash = ensureLeadingSlash(trimmed);
  const withoutTrailingSlash = withLeadingSlash.replace(/\/+$/, "");

  return withoutTrailingSlash || ROOT_BASE_PATH;
};

/** The router basename for this build ("/" outside preview deploys, e.g. "/__preview/pr-123" in one). */
export const getAppBasePath = (): string => {
  const value: unknown = import.meta.env.VITE_BASE_PATH;
  return normalizeBasePath(typeof value === "string" ? value : undefined);
};

/** Turns a router-relative path ("/login") into a document path that includes the basename. */
export const withAppBasePath = (path: string, basePath = getAppBasePath()): string => {
  const normalizedPath = ensureLeadingSlash(path);
  return basePath === ROOT_BASE_PATH ? normalizedPath : `${basePath}${normalizedPath}`;
};

/** Turns a document pathname into a router-relative path by removing the basename prefix. */
export const stripAppBasePath = (pathname: string, basePath = getAppBasePath()): string => {
  if (basePath === ROOT_BASE_PATH) {
    return pathname;
  }
  if (pathname === basePath) {
    return ROOT_BASE_PATH;
  }
  return pathname.startsWith(`${basePath}/`) ? pathname.slice(basePath.length) : pathname;
};
